// @ts-nocheck
import { AnimatePresence, mix, motion, MotionValue, useMotionValue, usePresence } from 'motion/react';
import React, { useRef, useState } from 'react';
import { elderFuthark, SVGData } from '../../../svg/SVGData';
import useDebounce from '../../../../utils/hooks/useDebounce';


const totalTransitionDuration = 8000; // ms
const delayRange = mix(.1, 2);
const durationVariation = mix(totalTransitionDuration * .75, totalTransitionDuration * 1.25);

let symbols = Object.keys(elderFuthark);

// interface SymbolSVGProps {
//     data: SVGData,
//     opacity: MotionValue<number>
//     pathlength: MotionValue<number>
// }

const GridSymbol: React.FC<{ cursorOffset?: number, index?: number }> = ({ cursorOffset = 0, index = 0 }) => {
    const [initiated, setInitiated] = useState(false);
    const [cursor, setCursor] = useState((cursorOffset) % symbols.length)
    const letterData = elderFuthark[symbols[cursor]];

    const delay = delayRange(Math.random());

    useDebounce(() => {
        setInitiated(true);
    }, delay * 1000, [])

    const [duration, setDuration] = useState(durationVariation(Math.random()));
    const suspend = useRef(false);
    const tSuspended = useRef(Date.now());
    const [triggerRebounce, setTriggerRebounce] = useState(false);

    useDebounce(() => {
        if (!initiated || suspend.current) return;
        setCursor((cursor + 1) % symbols.length);
        setDuration(durationVariation(Math.random()));
    }, duration, [triggerRebounce, initiated, cursor, duration])

    // const svgOpacity = useMotionValue(0);
    // const letterOpacity = useMotionValue(0);

    // const isPresent = usePresence()

    const handleOnPointerEnter = () => {
        suspend.current = true;
        tSuspended.current = Date.now();
    }

    const handleOnPointerLeave = () => {
        suspend.current = false;
        if ((Date.now() - tSuspended.current) > duration) {
            setTriggerRebounce(!triggerRebounce)
        }
    }

    if (!initiated) return <div className='grow h-3/4 aspect-square' />

    return (
        <AnimatePresence mode='wait'>
            <motion.div
                key={letterData.letter}
                className={`grow flex justify-center items-center h-3/4 p-2 aspect-square`}
                onPointerEnter={handleOnPointerEnter}
                onPointerLeave={handleOnPointerLeave}
            >
                {/* Symbol */}
                <motion.svg
                    className='h-full w-full'
                    viewBox={letterData.viewBox}
                >
                    <motion.path
                        key={letterData.letter}
                        fillRule='evenodd'
                        clipRule='evenodd'
                        initial={{ opacity: 0, pathLength: 0 }}
                        animate={{ opacity: 1, pathLength: 1, transition: { duration: duration / 2 / 1000, ease: 'easeOut' } }}
                        exit={{ opacity: 0, pathLength: 0, transition: { duration: duration / 8 / 1000, ease: 'easeInOut' } }}
                        fill='none'
                        stroke={'white'}
                        style={{ strokeWidth: .4 }}
                        d={letterData.d}
                    />
                </motion.svg>
            </motion.div>
        </AnimatePresence>
    )
}


const EdgePhotoGrid: React.FC = () => {

    return (
        <div className='w-full h-16 md:h-24 flex justify-center items-center bg-neutral-800 relative'>
            {[...Array(7).keys()].map((v) => <GridSymbol key={v} cursorOffset={v * 2} index={v} />)}
        </div>
    )
}

export default EdgePhotoGrid;